// ENV ESPECIFICS

const development = {
    API_URL: 'https://api.staging.shoppbud.com.br/',
} as const;

const staging = {
    API_URL: 'https://api.staging.shoppbud.com.br/',
} as const;

const production = {
    API_URL: 'https://api.shoppbud.com.br/',
} as const;

const envs = {
    development,
    production,
    staging,
} as const;

const mode = (import.meta.env.MODE || 'production').toLowerCase();
const env = (mode in envs ? mode : 'production') as keyof typeof envs;

//
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY ?? '';
const API_URL = import.meta.env.VITE_API_BASE_URL ?? envs[env].API_URL;
const RECAPTCHA_SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY ?? '';

const values = {
    ENV: env,
    GOOGLE_MAPS_API_KEY,
    SENTRY_DSN,
    API_URL,
    RECAPTCHA_SITE_KEY,
};

export default values;
